import { Component, ReactNode } from 'react'
import styles from 'components/features/pfm/SidebarPopup/SidebarPopupWithList.styl'
import cn from 'classnames'
import { BlockCorners } from 'interfaces/component'
import { SidebarPopupBase } from 'components/features/pfm/SidebarPopup/SidebarPopupBase'

export type SidebarPopupWithListProps = {
  corners: BlockCorners
  fill: boolean
  isEmptyState: boolean

  header: ReactNode
  footer: ReactNode

  hidePopupTimeoutId: number | null
  onRegisterHideTimeout: (timeoutId: number) => void
  onHidePopup: () => void
}

export class SidebarPopupWithList extends Component<SidebarPopupWithListProps> {
  render () {
    const {
      corners, fill,
      header, footer,
      hidePopupTimeoutId, onRegisterHideTimeout, onHidePopup,
      children, isEmptyState,
    } = this.props

    const popupClassName = cn(styles.popup, {
      [styles.allCorners]: corners === 'all',
      [styles.rightCorners]: corners === 'right',
      [styles.fill]: fill,
      [styles.isEmptyState]: isEmptyState,
    })

    return (
      <SidebarPopupBase
        className={ popupClassName }
        hidePopupTimeoutId={ hidePopupTimeoutId }
        onRegisterHideTimeout={ onRegisterHideTimeout }
        onHidePopup={ onHidePopup }
      >
        <header className={ styles.header }>{ header }</header>
        { children }
        <footer className={ styles.footer }>{ footer }</footer>
      </SidebarPopupBase>
    )
  }
}
